/*
    Description: get more infographics -- click the show more button and get more infographics for the site 
    Author URI: https://destinationsalesandmarketinggroup.com/
    Author: adillice
    Version: 1.0.0
*/

//import utility class for ajax call
import Utilities from "./utilities";

//Infographics class
class Infographics extends Utilities{

    // constructor
    constructor({

        // init button class
        buttonClass = "--js-load-infographics",

        // where to load our new infographics
        targetContainer = "--js-infographics",
        
        // individual infographic class
        itemClass = "infographics__list__item",

        // global loading gif
        loadingClass = "--loading",

        // init data set num
        dataNum = "data-num",

        // global hide class
        hideClass = "--hide"
    
    } = {}){

        // get constructor/params from Utilities
        super();

        // set main button class to load more infographics
        this.buttonClass = buttonClass;

        // get bttn DOM element
        this.button = (this.buttonClass) ?  document.querySelector(`.${this.buttonClass}`) : null;

        // get target container class
        this.targetClass = targetContainer;
        
        // get target container DOM element
        this.targetContainer = (this.targetClass) ?  document.querySelector(`.${this.targetClass}`) : null;

        // the post preview class
        this.itemClass = itemClass;

        // get currently loaded infographics in our container
        this.initialLoad = (this.targetContainer && this.itemClass) ? this.targetContainer.querySelectorAll(`.${this.itemClass}`).length : 0;

        // get nonce element 
        this.nonce = document.getElementsByName("more-infographics");

        // set loading class
        this.loading = loadingClass;

        // set hide class
        this.hide = hideClass;
        
        // get data attribute
        this.dataNum = dataNum;

        // get total infographics
        this.totalGraphics = (this.button) ? (this.button.getAttribute(this.dataNum) * 1) : 0;

        // fire off our main events
        this.events();

    }
    
    // init main events
    events(){
        
        // make sure we have our target container and button
        if(this.targetContainer && this.button){
            
            // check if we have more infographics
            if(this.initialLoad < this.totalGraphics){

                // add click event 
                this.button.addEventListener("click", this.getInfographics.bind(this));

            // no infographics
            }else{

                // remove button
                this.button.remove();

                // return
                return;
                
            }

        }

    }

    // ajax for more infographics
    getInfographics(e){
        
        // prevent default
        e.preventDefault();

        // get current count of infographics
        const currentInfographicCount = this.targetContainer.querySelectorAll(`.${this.itemClass}`).length;

        // add loading gif
        this.button.classList.add(this.loading); 

        // setup data
        const data = new FormData();

        // send current infographic count
        data.append("currentCount", currentInfographicCount);
        
        // make sure we have data
        if(this.nonce && this.nonce[0]) data.append("wp_nonce", this.nonce[0].value);

        // send ajax
        this.ajax({
            action:"moreInfographics",
            loading:this.button,
            data:data
        // success
        }).then((results) => {

            //parse results
            results = JSON.parse(results);

            // ERROR: die silently - but remove button
            if(results.error){
                
                //display msg
                for(const key in results.error) {
                    if(Object.hasOwnProperty.call(results.error, key)){
                        console.log(`%c ${results.error[key]}`, 'background:#f00; color:#fff');            
                    }
                }
                
                // remove button
                this.button.remove();

                //return
                return
                
            };

            // check for success and target container
            if(results.success && (results.success.length > 0) && this.targetContainer){

                // add html tags to DOM
                this.targetContainer.insertAdjacentHTML("beforeend", results.success);

                // check item again
                const checkCountAgain = (this.targetContainer) ? this.targetContainer.querySelectorAll(`.${this.itemClass}`).length : null;

                // check if we have all our items from the db -- if so remove the show more button
                if(checkCountAgain && (checkCountAgain >= this.totalGraphics)) this.button.remove();

            // ERROR: Api came back with nothing or we are missing our container
            }else{
                
                //display msg
                console.log(`%c Could not find the container ${this.targetContainer} and/or the ajax call retrieved no value.`, 'background:#f00; color:#fff');
                
                // remove button
                this.button.remove();

                //return
                return

            }

        // catch ajax error
        }).catch((err) => {
            
            //display msg
            console.log(`%c ${err}`, 'background:#f00; color:#fff');

        });

    }
    
}   

// export
export default Infographics;